import { Controller } from "@hotwired/stimulus"

// Formularz bazy wiedzy: lista szablonów zawężona do rodzaju bazy, a wybór skórki widoczny
// tylko przy szablonie "docs" (jedyny ze skórkami)
export default class extends Controller {
  static targets = ["select", "skin"]
  static values = { templates: Object }

  filterTemplates(event) {
    const kind = event.target.value
    const templates = this.templatesValue[kind]
    if (templates == null) return

    const select = this.selectTarget
    const current = select.value

    select.innerHTML = ""
    templates.forEach(t => {
      const option = document.createElement("option")
      option.value = t
      option.textContent = t
      select.appendChild(option)
    })

    // Zachowaj aktualny wybór jeśli dostępny w nowej liście
    if (templates.includes(current)) {
      select.value = current
    } else {
      select.value = templates[0]
    }
    this.toggleSkin()
  }

  toggleSkin() {
    if (!this.hasSkinTarget) return

    this.skinTarget.classList.toggle("hidden", this.selectTarget.value !== "docs")
  }
}
